
  function initReviewsSlider() {
  var swiper = new Swiper(".mySwiper", {
    spaceBetween: 30,
    loop:true,
     navigation: {
       nextEl: ".swiper-button-next",
       prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      348: {
        centeredSlides: true,
        slidesPerView: 1.2,
        spaceBetween: 10,
        centeredSlidesBounds: true,
      },
      640: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 15,
      }
    }
  });
}
function customreviewswiper(){
var swiper = new Swiper(".u-cus-reviews-wrapper", {
  slidesPerView: 1,
  infinite: true,
  loop:true,
  speed: 800, 
  pagination: {
    el: ".swiper-pagination",
    clickable: true,  
  },
});
}

function threestepslider() {
  var swiper = new Swiper(".reviews-umySwiper", {
    slidesPerView: 3,
    spaceBetween: 15,
    speed: 400,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      348: {
        centeredSlides: true,
        slidesPerView: 1.1,
        spaceBetween: 15,
        centeredSlidesBounds: true,
      },
      640: {
        centeredSlides: true,
        slidesPerView: 1.1,
        spaceBetween: 15,
        centeredSlidesBounds: true,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 15,
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.u-main-results-section[data-section-id]').forEach((section) => {
      let started = false;
      const counterDuration = parseFloat(section.dataset.counterDuration) || 2;
      const run = () => {
        if (started) return;
        started = true;
        section.querySelectorAll('.u-circle-loader').forEach((loader) => {
          const target = +loader.dataset.target;
          const numberEl = loader.querySelector('.u--results--loader span');
          const circle = loader.querySelector('.u-circle-progress');
          const circumference = 339.292;
          let current = 0;
          const interval = Math.max(20, (counterDuration * 1000) / target);
          const timer = setInterval(() => {
            current++;
            numberEl.textContent = current + '%';
            const offset = circumference - (current / 100) * circumference;
            circle.style.strokeDashoffset = offset;
            if (current >= target) {
              clearInterval(timer);
            }
          }, interval);
        });
      };
      new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) run();
        },
        { threshold: 0.3 }
      ).observe(section);
    });
  });

  
(function() {
  function initTimer(timerEl) {
    const sectionId = timerEl.dataset.sectionId;
    const endKey = timerEl.dataset.endKey;
    const hrsEl = document.getElementById(`hrs-${sectionId}`);
    const minEl = document.getElementById(`min-${sectionId}`);
    const secEl = document.getElementById(`sec-${sectionId}`);
    if (!hrsEl || !minEl || !secEl) return;
    let endTime = localStorage.getItem(endKey);
    const now = Date.now();
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    if (!endTime || now > parseInt(endTime, 10)) {
      endTime = midnight.getTime();
      localStorage.setItem(endKey, endTime);
    } else {
      endTime = parseInt(endTime, 10);
    }
    function update() {
      let diff = endTime - Date.now();
      if (diff <= 0) {
        const newMidnight = new Date();
        newMidnight.setHours(24, 0, 0, 0);
        endTime = newMidnight.getTime();
        localStorage.setItem(endKey, endTime);
        diff = endTime - Date.now();
      }
      const hrs = Math.floor(diff / 3600000);
      const min = Math.floor((diff % 3600000) / 60000);
      const sec = Math.floor((diff % 60000) / 1000);

      hrsEl.textContent = String(hrs).padStart(2, "0");
      minEl.textContent = String(min).padStart(2, "0");
      secEl.textContent = String(sec).padStart(2, "0");
    }
    update();
    setInterval(update, 1000);
  }
  document.querySelectorAll(".u-timer").forEach(initTimer);
})();
